import { render } from "./ConnectionType.vue?vue&type=template&id=c10aa510&scoped=true"
import script from "./ConnectionType.vue?vue&type=script&lang=js"
export * from "./ConnectionType.vue?vue&type=script&lang=js"

import "./ConnectionType.vue?vue&type=style&index=0&id=c10aa510&scoped=true&lang=css"

import exportComponent from "/Users/einarbragi/Code/hlada.is/hlada-vue-mapbox/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c10aa510"]])

export default __exports__